import { Toast,PullRefresh  } from 'vant';

// var timer;
var that;
export default {

};
